import React, { useState } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { createFolderRule } from 'api/folders';
import Popup from 'components/Popup';
import SelectInput from 'components/Form/SelectInput';
import TextInput from 'components/Form/TextInput';
import Button from 'components/Button';

export default function FolderAddRulePopup({
    visible,
    setVisible,
    present = []
}) {

    const { folderId } = useParams();
    const cache = useQueryClient();
    const [selected, setSelected] = useState(null);


    const { mutate: update } = useMutation({
        mutationKey: ['createFolderRule'],
        mutationFn: createFolderRule,
        onSuccess: () => {
            cache.invalidateQueries(['folders', folderId]);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error creating folder-rule:", error);
        }
    });

    const selectOptions = [
        {
            value: "chunk_size",
            label: "Dimensione Chunk",
            type: "text"
        },
        {
            value: "chunk_overlap",
            label: "Dimensione Overlap",
            type: "text"
        },
        {
            value: "split_type",
            label: "Tipologia di suddivisione",
            type: "select",
            options: [
                { value: 'size', label: 'Per dimensione' },
                { value: 'paragraph', label: 'Per paragrafo' },
                { value: 'sentence', label: 'Per frase' },
                { value: 'character', label: 'Per carattere' },
                { value: 'intelligent', label: 'Intelligente' },
            ]
        },
        {
            value: "meilisearch",
            label: "Ricerca tramite Meilisearch",
            type: "boolean"
        },
        {
            value: "qdrant",
            label: "Categorizzazione tramite Qdrant",
            type: "boolean"
        }
    ];


    function onSubmitHandler(e) {
        e.preventDefault();
        return update({
            id: folderId,
            data: {
                rule: {
                    type: e.target.type.value,
                    value: e.target.value.value
                }
            }
        });
    }

    function changeType(e) {
        const valueSelected = e.target.selectedOptions[0].value;
        const selected = selectOptions.find(({ value }) => value === valueSelected)
        setSelected(selected)
    }


    return (
        <Popup
            visible={visible}
            setVisible={setVisible}
        >
            <form onSubmit={onSubmitHandler} className='flex flex-col gap-4'>
                {selectOptions &&
                    <SelectInput
                        label="Seleziona tipologia"
                        name="type"
                        onChange={changeType}
                        required
                        options={selectOptions?.filter(element => !present?.includes(element.value))}
                        placeholder="Seleziona una tipologia"
                    />
                }
                {selected?.type === 'text' &&
                    <TextInput
                        label="Valore"
                        name="value"
                        required
                    />
                }
                {selected?.type === 'select' &&
                    <SelectInput
                        label="Valore"
                        name="value"
                        options={selected?.options}
                        placeholder="Seleziona un valore"
                        required
                    />
                }
                {selected?.type === 'boolean' &&
                    <SelectInput
                        label="Valore"
                        name="value"
                        required
                        options={[
                            { value: 'true', label: 'Abilita' },
                            { value: 'false', label: 'Disabilita' }
                        ]}
                        placeholder="Seleziona un valore"
                    />
                }

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button submit>Conferma</Button>
                </div>
            </form>
        </Popup>
    )
}